import { render } from "./ThirdStep.vue?vue&type=template&id=05cb3286"
import script from "./ThirdStep.vue?vue&type=script&lang=js"
export * from "./ThirdStep.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__